module.exports = __webpack_public_path__ + "static/media/edi5.a0b9a16a.jpeg";